/*
  ==========================================
  COLLECTION → PRODUCT → BACK RESTORATION
  With Flash Prevention
  ==========================================
*/

(function () {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  /*
    ------------------------------------------
    SAVE SCROLL POSITION
    ------------------------------------------
  */

  document.addEventListener('mousedown', function (e) {
    const productLink = e.target.closest('a[href*="/products/"]');
    if (!productLink) return;

    const state = {
      collectionUrl: window.location.pathname + window.location.search,
      scrollY: window.scrollY
    };

    sessionStorage.setItem(
      'collectionScrollState',
      JSON.stringify(state)
    );
  });


  /*
    ------------------------------------------
    RESTORE SCROLL POSITION
    ------------------------------------------
  */

  window.addEventListener('pageshow', function () {
    const saved = sessionStorage.getItem('collectionScrollState');
    if (!saved) {      
      document.documentElement.classList.remove('is-restoring-scroll');
      return;
    }     

    const state = JSON.parse(saved);

    const currentUrl =
      window.location.pathname + window.location.search;

    if (currentUrl !== state.collectionUrl) return;

    const restoreScroll = () => {
      window.scrollTo(0, state.scrollY);
    };
    
    restoreScroll();

    requestAnimationFrame(() => {
      requestAnimationFrame(restoreScroll);
    });

    setTimeout(restoreScroll, 150);

    // Remove loader after scroll stabilizes
    setTimeout(() => {
      document.documentElement.classList.remove('is-restoring-scroll');
    }, 300);
  });
})();
